import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import StarRating from "../components/common/StarRating";
import CtaBanner from "../components/common/CtaBanner";
import { testimonials } from "../data/content";

export default function Testimonials() {
  return (
    <>
      <PageHeader title="Testimonials" crumbs={[{ label: "Testimonials" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Testimonials"
            title="What Our <span>Riders Say</span>"
            text="Thousands of happy customers trust Taxi24hrs for their daily journeys."
          />
          <div className="grid grid-3">
            {testimonials.map((t, i) => (
              <div className="testi-card card" key={i}>
                <StarRating rating={t.rating} />
                <p className="testi-text">"{t.text}"</p>
                <div className="testi-author">
                  <div>
                    <h4>{t.name}</h4>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
